export default __webpack_public_path__ + "static/insight-light-97aa2166fc48f2d16a02ca5dabddcde2.png";